import { Component } from "@angular/core";

@Component({
    selector: 'license-portal',
    styles: [require('./license-portal.component.scss')],
    template: require('./license-portal.component.html')
})

export class LicensePortalComponent {  
    isVisible=true;  
        toggleSideNav(){
            this.isVisible=!this.isVisible;
        }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/license-portal.component.ts